module.exports = __webpack_public_path__ + "img/3.fc852718.jpg";